export const GET_CONFIGURATION_PARAMS = "GET_CONFIGURATION_PARAMS";
export const GET_CONFIGURATION_PARAMS_FAIL = "GET_CONFIGURATION_PARAMS_FAIL";
export const GET_CONFIGURATION_PARAMS_SUCCESS =
  "GET_CONFIGURATION_PARAMS_SUCCESS";
